import CommonHeading from "../../../../Components/CommonHeading";
import DateSection from "./DateSection";
import Selector from "./Select";
import TableHead from "./TableHead";
import { useFormik } from "formik";
import * as Yup from "yup";
import Searchbar from "../../../../Components/Searchbar";
import { useCallback } from "react";
import { useStudentPaymentTransactions } from "../../../../Store/CashControlStore/StudentPaymentTransactions";
import { useMemo } from "react";
import ExportExcel from "../../../../Components/ExportExcel";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Heading() {
  const {
    loadItems,
    queryParams,
    updateParams,
    teachers_list,
    branches_list,
    payment_types,
    setLoading,
  } = useStudentPaymentTransactions();

  const searchAction = useCallback(async (payload) => {
    updateParams({ search_query: payload.term, page: 1 });
    setLoading(true);
    await loadItems(
      new URLSearchParams({
        ...queryParams,
        page: 1,
        search_query: payload.term,
      }).toString()
    );
    setLoading(false);
  });

  const { t } = useTranslation();

  const initialValues = {
    term: "",
  };
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      term: Yup.string().min(1, t("Qidiruvni kiriting!")),
    }),
    onSubmit: (values) => {
      searchAction({
        term: values.term,
      });
    },
  });

  const handleChange = (e) => {
    formik.setFieldValue("term", e.target.value);
    searchAction({
      term: e.target.value,
    });
  };

  const optionsStaffs = useMemo(() => {
    return (
      teachers_list?.map((element) => ({
        label: element.name,
        value: element.id,
      })) || []
    );
  }, [teachers_list]);

  const optionsBranchs = useMemo(() => {
    return (
      branches_list?.map((element) => ({
        label: element.name,
        value: element.id,
      })) || []
    );
  }, [teachers_list]);

  const optionsPayment = useMemo(() => {
    return (
      payment_types?.map((element) => ({
        label: element.name,
        value: element.value,
      })) || []
    );
  }, [teachers_list]);

  const user = JSON.parse(localStorage.getItem("token"));

  const queryString = new URLSearchParams({
    ...queryParams,
    download: "excel",
    token: user.access || "",
  }).toString();

  return (
    <CommonHeading
      topItems={
        <>
          <Searchbar
            value={formik.values.term}
            handleChange={(e) => handleChange(e)}
            handleSubmit={formik.handleSubmit}
          />
          <Selector options={optionsStaffs} property={t("O'qituvchi")} />
          <Selector options={optionsBranchs} property={t("Filial")} />
          <Selector options={optionsPayment} property={t("To'lov turi")} />
          <DateSection />
        </>
      }
      rightItems={
        <Link
          to={
            `https://admin.smartportal.uz/
api/finance/payments/?` + queryString
          }
          download
          target={"_blank"}
        >
          <ExportExcel />
        </Link>
      }
      tableHead={<TableHead />}
    />
  );
}
